import { Box } from '@chakra-ui/react';
import React from 'react';

import '../../styles/common.scss';

export const HighlightBox = ({
  backgroundColor = 'white',
  children,
}: {
  backgroundColor?: string;
  children: React.ReactChild | (React.ReactChild | null)[];
}) => {
  return (
    <Box
      background={backgroundColor}
      borderRadius="8px"
      padding="32px"
      mb="32px"
      boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1)"
    >
      {children}
    </Box>
  );
};
